import React from "react";
import { DragControls, Reorder, useDragControls, useMotionValue } from "framer-motion";
import { MdDragIndicator } from "react-icons/md";
import { useRaisedShadow } from "./use-raised-shadow";

interface ContextMenuProps {
	isOpen: boolean;
	setViewGroups: React.Dispatch<React.SetStateAction<ViewGroupOptions[]>>;
	viewGroups: ViewGroupOptions[];
}

export default function ContextMenu(props: ContextMenuProps) {
	return (
		<div className="w-40">
			<h2 className="text-md mb-2 whitespace-nowrap pl-3 text-base font-medium">
				View Groups
			</h2>
			<Reorder.Group
				axis="y"
				onReorder={props.setViewGroups}
				values={props.viewGroups}
				className="relative rounded p-0"
			>
				{props.viewGroups.map((item) => (
					<Item
						key={item.name}
						item={item}
						setViewGroups={props.setViewGroups}
					/>
				))}
			</Reorder.Group>
		</div>
	);
}

interface ItemProps {
	item: ViewGroupOptions;
	setViewGroups: React.Dispatch<React.SetStateAction<ViewGroupOptions[]>>;
}

export interface ViewGroupOptions {
	name: string;
	on: boolean;
}

export const Item = ({ item, setViewGroups }: ItemProps) => {
	const y = useMotionValue(0);
	const boxShadow = useRaisedShadow(y);
	const dragControls = useDragControls();

	return (
		<Reorder.Item
			value={item}
			id={item.name}
			style={{ y, boxShadow }}
			dragListener={false}
			dragControls={dragControls}
			className="relative flex items-center justify-between rounded-md bg-white px-3 py-2 text-gray-600"
		>
			<div className="flex items-center gap-2 ">
				<input
					id={item.name + "_checkbox"}
					type="checkbox"
					className="my-auto h-4 w-4"
					defaultChecked={item.on}
					onChange={ () => {
						setViewGroups((prevState) =>
							prevState.map((viewGroup) => {
								if (viewGroup.name === item.name) {
									return { ...viewGroup, on: !item.on };
								}
								return viewGroup;
							})
						);
					}
					}
				/>
				<label className="leading-none" htmlFor={item.name + "_checkbox"}>
					{item.name}
				</label>
			</div>
			<ReorderIcon dragControls={dragControls} />
		</Reorder.Item>
	);
};

interface IconProps {
	dragControls: DragControls;
}

export function ReorderIcon({ dragControls }: IconProps) {
	return (
		<MdDragIndicator
			className="flex cursor-grab"
			size={18}
			onPointerDown={(event) => dragControls.start(event)}
		/>
	);
}
